import { createEventDispatcher } from 'svelte';

export default () => {
    const dispatch = createEventDispatcher();
    return (message) => {console.log('dispatching'); dispatch('message', message)};
};